import React, { memo } from 'react';
import { useDispatch } from 'react-redux';
import { BaseConfirmDialog } from 'reactApp/components/BaseConfirmDialog/BaseConfirmDialog';
import { reportDocument } from 'reactApp/modules/weblinkAccessControl/weblinkAccessControl.actions';

import type { Props } from './RemoveDialog.types';
import { modalContent } from './ReportDialog.helpers';

export const ReportDialog = memo(({ weblink_id, source, onClose }: Props) => {
    const dispatch = useDispatch();

    const onConfirm = () => {
        dispatch(reportDocument({ weblink_id, source }));
        onClose();
    };

    return (
        <BaseConfirmDialog
            dataQAId="report-confirmation-dialog"
            renderHeader={modalContent.renderHeader}
            successButtonText="Пожаловаться"
            cancelButtonText="Отменить"
            buttons={modalContent.buttons}
            onClose={onClose}
            onSuccess={onConfirm}
            renderContent={modalContent.renderContent}
            smallButtons
            size="middle"
            closeOnDimmerClick
        />
    );
});

ReportDialog.displayName = 'ReportDialog';
